import { KitTouchableIcon } from '@omni/kit/components';
import Spacing from '@omni/kit/theming/Spacing';
import {
  NavigationProp,
  ParamListBase,
  useNavigation,
} from '@react-navigation/native';
import React, { ReactElement, useState } from 'react';
import { Platform, View } from 'react-native';

import useSnoozeNotifications from '../../hooks/useSnoozeNotifications';
import { ACCOUNT_SCREEN, CHAT_SETTINGS_MODAL } from '../../shared/Constants';
import SnoozeNotificationsActionSheet from './chat/SnoozeNotificationsActionSheet';

const debug = require('debug')(
  'tca:chat:components:ChannelListRightNavButtons'
);

const ChannelListRightNavButtons: React.FC = (): ReactElement => {
  // Navigation
  let navigation: NavigationProp<ParamListBase>;
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    navigation = useNavigation();
  } catch {
    navigation = {} as NavigationProp<ParamListBase>; // Provide a fallback object
  }
  const [isActionSheetVisible, setIsActionSheetVisible] = useState(false);
  const { snoozePeriod, _setSnoozePeriod } = useSnoozeNotifications();

  const _openChatSettings = () => {
    debug('_openChatSettings');
    navigation.navigate(CHAT_SETTINGS_MODAL);
  };

  const _openAccountScreen = () => {
    debug('_openAccountScreen');
    navigation.navigate(ACCOUNT_SCREEN);
  };

  return (
    <View style={{ flexDirection: 'row' }}>
      <View style={{ width: Spacing.m }} />
      {Platform.OS !== 'web' ? (
        <KitTouchableIcon
          name={snoozePeriod.isSnoozeOn ? 'notifications-off' : 'notifications'}
          onPress={() => setIsActionSheetVisible(true)}
          buttonSize={40}
          size={20}
        />
      ) : null}
      <KitTouchableIcon
        name='settings'
        onPress={_openChatSettings}
        buttonSize={40}
        size={20}
      />
      {Platform.OS === 'web' ? (
        <KitTouchableIcon
          name='person'
          onPress={_openAccountScreen}
          buttonSize={40}
          size={20}
        />
      ) : null}

      <SnoozeNotificationsActionSheet
        isActionSheetVisible={isActionSheetVisible}
        setIsActionSheetVisible={setIsActionSheetVisible}
        isSnoozed={snoozePeriod.isSnoozeOn}
        snoozedUntil={snoozePeriod.endAt}
        setSnoozePeriod={_setSnoozePeriod}
      />
    </View>
  );
};

export default ChannelListRightNavButtons;
